import ApiService from '../api/ApiService';

const errors = {
  401: 'api_error_unauthorized',
  404: 'api_error_route_not_found',
  400: 'api_error_registration_or_mileage_unkown',
  405: 'api_error_registration_or_mileage_unkown',
  500: 'api_error_internal_error',
};
// const infos = ['_carDetails', '_quotation', '_versions'];

// Get AAA
// export default async function (registration, mileage) {
//   if (!registration || !mileage) throw new Error(errors[400]);
//
//   const response = await ApiService('getQuotationByRegistration', {
//     registration,
//     mileage,
//   });
//
//   if (Object.prototype.hasOwnProperty.call(errors, response.status)) throw new Error(errors[response.status]);
//   if (response.status > 299) throw new Error('api_error_internal_error');
//
//   const vehicle = response.data;
//
//   infos.forEach((info) => {
//     if (!Object.prototype.hasOwnProperty.call(vehicle, info)) {
//       throw new Error('api_error_internal_error');
//     }
//   });
//
//   return vehicle;
// }

// Get AAA
export async function getQuotationbyVersionId(id, mileage, year) {
  const response = await ApiService(
    'getQuotation',
    {
      versionId: id,
      dateMecYear: year,
      mileage,
    },
    { origin: 'autobizCarcheck' },
  );

  if (Object.prototype.hasOwnProperty.call(errors, response.status)) throw new Error(errors[response.status]);
  if (response.status > 299) throw new Error('api_error_internal_error');

  const quotation = response.data;

  return quotation;
}
